export const GatewaySessionErrorCode = {
  CREDENTIALS_MISSING: 'CREDENTIALS_MISSING',
  GATEWAY_SESSION_UNAVAILABLE: 'GATEWAY_SESSION_UNAVAILABLE',
  INSTALLATION_NOT_FOUND: 'INSTALLATION_NOT_FOUND',
  GATEWAY_SESSION_ERROR: 'GATEWAY_SESSION_ERROR',
  BRIDGE_ERROR: 'BRIDGE_ERROR',
};

export const AUTH_RECOVERY_SESSION_CODES = new Set([
  GatewaySessionErrorCode.CREDENTIALS_MISSING,
  GatewaySessionErrorCode.GATEWAY_SESSION_UNAVAILABLE,
  GatewaySessionErrorCode.INSTALLATION_NOT_FOUND,
]);
